import { jsx } from "react/jsx-runtime";
import cx from "classnames";
import {
  TypographyPrefixedContext
} from "@ingka/typography-shared";
const Text = (props) => {
  const {
    prefix = "",
    className,
    tagName = "div",
    textStyle = "Body.M",
    colour = true,
    children,
    ...other
  } = props;
  const typography = new TypographyPrefixedContext(prefix);
  const { typographyClassName, textStyleGroup } = typography.fromTextStyleName(textStyle);
  const baseClass = `${prefix}text`;
  const classes = cx(
    colour && baseClass,
    typographyClassName,
    colour && ["Body", "Caption"].includes(textStyleGroup) ? `${baseClass}--lighter` : "",
    className
  );
  const Tag = tagName || "div";
  return /* @__PURE__ */ jsx(Tag, { ...other, className: classes, children });
};
var Text_default = Text;
export {
  Text_default as default
};
